export const permit = (object, permit) => {
    const [model, action] = permit.split('.');
    return object?.[model]?.[action] ? object[model][action] : false;
}
